import React, {lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';

// import Loading from './components/Loading/Loading';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
// import SmoothScroll from './pages/SmoothScroll';
import Nftrarity from './pages/nftrarity/Nftrarity';

const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Profile = lazy(() => import('./pages/Profile/Profile'));

function App() {
  return (
    <>
    {/* <SmoothScroll /> */}
    <ErrorBoundary>
      <Router>
        <Layout>
          {/* <Suspense fallback={<Loading />}> */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/Nftrarity" element={<Nftrarity />} />
              <Route path="/profile" element={<Profile />} />
              {/* Add more routes here */}
            </Routes>
          {/* </Suspense> */}
        </Layout>
      </Router>
    </ErrorBoundary>
    </>
  );
}
export default App;
